export default __webpack_public_path__ + "static/media/money-pariuri.af970ec9.svg";